import React from 'react';

const EditorEnvironmentContext = React.createContext({
  isFlutterPresent: false,
});

const EditorEnvironmentProvider = ({ children }) => {
  const isFlutterPresent = !!window.FlutterCallback;
  return (
    <EditorEnvironmentContext.Provider
      value={{
        isFlutterPresent,
      }}
    >
      {children}
    </EditorEnvironmentContext.Provider>
  );
};

export { EditorEnvironmentContext };
export default EditorEnvironmentProvider;
